import { ChangeEvent } from 'react'
import { Btn, H5 } from '../../../../../AbstractElements';
import { Input, InputGroup } from 'reactstrap';
import { Quantity } from '../../../../../utils/Constant';
import { ModalQuantityProp } from '../../../../../Type/Application/Ecommerce/Product';

const ModalQuantity = ({ quantity, setQuantity }: ModalQuantityProp) => {
  const minusQty = () => quantity > 1 && setQuantity(quantity - 1);
  const plusQty = () => quantity >= 1 && setQuantity(quantity + 1);
  const changeQty = (e: ChangeEvent<HTMLInputElement>) => setQuantity(parseInt(e.target.value));

  return (
    <>
      <H5 className="f-w-600 mb-2">{Quantity}</H5>
      <fieldset className="border-0">
        <InputGroup className="bootstrap-touchspin">
          <Btn className="bootstrap-touchspin-down b-r-0" color='primary' onClick={minusQty}>
            <i className="fa fa-minus"></i>
          </Btn>
          <Input className="touchspin text-center" type="text" name="quantity" value={quantity} onChange={(e) => changeQty(e)} />
          <Btn className="bootstrap-touchspin-up btn-square b-r-0" onClick={plusQty} color='primary'>
            <i className="fa fa-plus"></i>
          </Btn>
        </InputGroup>
        <br />
      </fieldset>
    </>
  )
}

export default ModalQuantity